import {isString} from 'remeda'
import {JsonPrim} from 'shared/type'
import {P, match} from 'ts-pattern'

export type CsvRow = Record<string, JsonPrim | undefined>

export const objectToCsv = <T extends CsvRow>(data: T[], cols?: (keyof T)[]) => {
  const headers = cols ?? (data.length > 0 ? (Object.keys(data[0]!) as (keyof T)[]) : [])
  if (headers.length === 0) return ''

  return [
    headers.join(','),
    ...data.map(row =>
      headers
        .map(header => row[header] as JsonPrim)
        .map(v =>
          match(v)
            .with(P.nullish, () => '')
            .otherwise(v => (isString(v) ? `"${('' + v).replace(/"/g, '""')}"` : v.toString()))
        )
        .join(',')
    )
  ].join('\n')
}
